import block from 'propmods';
import React from 'react';
import { Settings } from '../../model/settings';
import { SkillWithLastOperation, Channel } from '../../model/skill';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import SkillCard, { SkillCardTheme } from '../SkillCard/SkillCard';
import { getIsArabicSkillName } from 'client/utils/skill';

import './CardList.scss';

interface CreationCardProps {
    onClick: () => void;
    disabled: boolean;
}

export interface CardListProps {
    skills: SkillWithLastOperation[];
    theme: SkillCardTheme;
    creationCard?: CreationCardProps;
}

const b = block('CardList');

function byUpdateTime(l: SkillWithLastOperation, r: SkillWithLastOperation) {
    const lUpdateTime = new Date(l.skill.updatedAt).getTime();
    const rUpdateTime = new Date(r.skill.updatedAt).getTime();

    if (lUpdateTime > rUpdateTime) {
        return 1;
    }

    if (rUpdateTime > lUpdateTime) {
        return -1;
    }

    return 0;
}

function getLogo(settings: Settings) {
    return settings.logo2 ? settings.logo2.url : '';
}

export default function CardList(props: CardListProps) {
    return (
        <ErrorBoundary>
            <div {...b(props)}>
                {props.creationCard && (
                    <SkillCard
                        theme={props.creationCard.disabled ? 'forbidden' : 'create'}
                        onClick={!props.creationCard.disabled ? props.creationCard.onClick : undefined}
                        // irrelevant
                        channel={Channel.AliceSkill}
                    />
                )}
                {props.skills.sort(byUpdateTime).map(({ skill, lastOperation }) => {
                    return (
                        <div {...b('item')} key={skill.id}>
                            <SkillCard
                                id={skill.id}
                                logo={getLogo(skill) || getLogo(skill.draft)}
                                theme={props.theme}
                                title={skill.onAir ? skill.name : skill.draft.name}
                                rtl={getIsArabicSkillName(skill)}
                                status={
                                    lastOperation
                                        ? { model: 'operation', status: lastOperation.type }
                                        : { model: 'draft', status: skill.draft.status }
                                }
                                channel={skill.channel}
                                updatedAt={lastOperation ? lastOperation.createdAt : skill.draft.updatedAt}
                            />
                        </div>
                    );
                })}
            </div>
        </ErrorBoundary>
    );
}
